import { useEffect, useRef, useState, type RefObject } from 'react';

/**
 * Ширина елемента в px (ResizeObserver): змінюється разом із вікном, лівим меню й правими панелями (ШІ, форма) — сітка записів підбирає
 * стовпці за доступною шириною, як прототип v4 (fitW). До першого вимірювання — `initial`.
 */
export function useElementWidth<T extends HTMLElement>(initial: number): [RefObject<T>, number] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(initial);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    setWidth(el.clientWidth);
    const observer = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width;
      if (w !== undefined) setWidth(Math.round(w));
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
